import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    currentScreen: -1,
    sufferCard: false,
    colorHorse: 1,
    isWin: false,
    popupID: 1,
    data: {
      speed: [[3, 2, 3, 1, 1, 1, 3], [1, 1, 2, 1, 1, 3], [3, 2, 1, 1, 3, 2]],
      stamina: [[2, 3, 1, 2, 1, 2, 3], [2, 2, 1, 1, 3, 1], [1, 2, 3, 3, 0, 3]],
      brave: [[1, 1, 2, 3, 1, 2, 3], [3, 2, 2, 1, 2, 0]],
      calm: [[0, 1, 1, 1, 3, 2, 3], [4, 3, 2, 1, 0, -1, 3, 2, 1, 0, -1, -2]],
      health: [[2, 1, 1, 2, -1, 3, 3], [2, 1, 1, 2, -1, -1]]
    },
    horseUser: [],
    horsePc: [],
    array_temp: [],
    temp: 0,
    arrayTotalDNA: {},
    arraySpecialDNA: {},
    specialCard: {},
    replay: false,
    replaySpecialcard: false,
    dice: {
      user: [0, 0],
      pc: [0, 0]
    },
    turn: 0,
    isAsmallerB: true,
    distanceOneTurnA: 0,
    distanceOneTurnB: 0,
    finalDistanceA: 0,
    finalDistanceB: 0,
    isStopSufferCard: false,
    raceStage: {
      user: false,
      pc: false
    },
    diceStage: {
      user: false,
      pc: false
    },
    pcDiceStatus: false,
    showRaceTextStart: false,
    showRaceTextGoal: false,
    soundMute: true,
    soundList: [
      'bgm01.mp3', 'bgm02.mp3', 'bgm03.mp3', 'btn01.mp3',
      'roulette.mp3', 'unicorn.mp3', 'fanfare.mp3', 'dice.mp3',
      'run.mp3', 'goal.mp3', 'youwin.mp3', 'youlose.mp3'
    ],
    bgm: {
      'welcome': 0,
      'card': 1,
      'decisionCard': 1,
      'specialCard': 1,
      'race': 2,
      'result': 0
    },
    adnSpecial: -1,
    resetStatus: false
  },
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/store.js